import React, { useRef, useEffect } from 'react';
import useDevices from '../hooks/useDevices';
import { Spin } from 'antd';
import DevicePanel from './DevicePanel';

function Sidebar({
  onSelectDevice,
  selectedDeviceId,
  onShowInfo,
  flyToDevice,
  openPanels = [],
  setOpenPanels,
  forceOpenPanel
}) {
  const { devices, loading } = useDevices();

  const scrollContainerRef = useRef(null);
  const itemRefs = useRef({});

  const togglePanel = id => {
    setOpenPanels(prev =>
      prev.includes(id)
        ? prev.filter(openId => openId !== id)
        : [...prev, id]
    );
  };

  // 🔥 AUTO SCROLL CUANDO CAMBIA EL DEVICE SELECCIONADO
  useEffect(() => {
    if (!selectedDeviceId) return;

    const el = itemRefs.current[selectedDeviceId];
    const container = scrollContainerRef.current;

    if (!el || !container) return;

    const elTop = el.offsetTop;
    const elBottom = elTop + el.offsetHeight;

    const containerTop = container.scrollTop;
    const containerBottom = containerTop + container.clientHeight;

    const isVisible =
      elTop >= containerTop &&
      elBottom <= containerBottom;

    if (!isVisible) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  }, [selectedDeviceId]);

  return (
    <div
      style={{
        width: 260,
        paddingTop: 16,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        minHeight: 0,
        borderRight: '1px solid #e5e7eb',
      }}
    >
      <div style={{ fontWeight: 700, fontSize: 18, color: '#0075C9', padding: '0 0 10px 16px' }}>
        Devices
      </div>

      {loading ? (
        <div style={{ flex: 1, display:"flex", justifyContent:"center", alignItems:"center" }}>
          <Spin size="large" />
        </div>
      ) : (
        <div
          ref={scrollContainerRef}
          style={{ flex: 1, minHeight: 0, overflowY: 'auto' }}
        >
          {devices.map(device => (
            <div
              key={device.id}
              ref={el => itemRefs.current[device.id] = el}
            >
              <DevicePanel
                device={device}
                selected={selectedDeviceId === device.id}
                open={openPanels.includes(device.id)}
                onToggle={togglePanel}
                onSelect={onSelectDevice}
                onShowInfo={onShowInfo}
                flyToDevice={flyToDevice}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Sidebar;
